export class RegexConstants {
    public static readonly FLOOR_NUMBER_WITH_F_REGEX: RegExp = /(\d+)f$/i;
    public static readonly MP4_EXTENSION: RegExp = /\.mp4(?:\?.*)?$/i;

    public static readonly RGB_OR_RGBA_FUNCTION_FILL: RegExp =
        /^rgba?\(\s*([+-]?\d+%?)\s*,\s*([+-]?\d+%?)\s*,\s*([+-]?\d+%?)(?:\s*,\s*([+-]?[\d.]+%?))?\s*\)$/i;

    public static readonly HTML_TAG: RegExp = /<[^>]+>/g;
    public static readonly MULTIPLE_SPACES: RegExp = /\s+/g;
}
